import React, { Component } from "react";

import VeranstaltungServiceInstance from "../services/VeranstaltungService";

import asWizard from "./Wizard";

import { ValidatableInput, ValidatableSelect, valueIsNotEmpty, isValidJahrgang, valueIsNotEmptyAndLength, isValidEMail, validateData } from "./Validation"

import AnmeldungSportlerSubmit from "./AnmeldungSportlerSubmit";
import InputChangeHandler from "./InputChangeHandler";

class AnmeldungSportler extends Component {

    constructor(props) {
        super(props);
        this.state = {
            wasValidated: false
            , formData: {
                inputVorname: { value: "", validator: valueIsNotEmptyAndLength, invalidText: "Vorname muss eingegeben werden und darf maximal 40 Zeichen lang sein." }
                , inputNachname: { value: "", validator: valueIsNotEmptyAndLength, invalidText: "Nachname muss eingegeben werden und darf maximal 40 Zeichen lang sein." }
                , inputMail: { value: "", validator: isValidEMail, invalidText: "Bitte geben Sie eine korrekte E-Mail-Adresse ein. An diese wird später die Anmeldebestätigung versendet." }
                , inputJahrgang: { value: "", validator: isValidJahrgang, invalidText: "Jahrgang muss 4-stellig eingegeben werden (z.B. 1965)" }
                , inputGeschlecht: { value: "M", label: "männlich", validator: valueIsNotEmpty }
                , inputVerein: { value: "", validator: valueIsNotEmptyAndLength }
                , inputVerband: { value: "" }
                , inputStartpass: { value: "" }
                , inputWettbewerb: { value: "", label: "", validator: valueIsNotEmpty, invalidText: "Mindestens ein Wettbewerb muss ausgewählt werden." }
            }
            , event: null
        };

        this.inputChangeHandler = new InputChangeHandler("formData", this);
    }

    componentDidMount() {
        const eventId = Number(this.props.match.params.id);
        VeranstaltungServiceInstance.getById(eventId).then(event => {
            
            /* Wettbewerb vorauswählen, falls nur einer vorhanden ist  */
            const wettbewerbe = event.wettbewerbe;
            let wettbewerbValue = "";
            let wettbewerbLabel = "";
            
            if(wettbewerbe.length === 1) {
                wettbewerbValue = wettbewerbe[0].id;
                wettbewerbLabel = wettbewerbe[0].bezeichnung;
            }

            const newFormData = { ...this.state.formData };
            newFormData.inputWettbewerb.value = ""+wettbewerbValue;
            newFormData.inputWettbewerb.label = wettbewerbLabel;
            /***********************************************************/

            this.setState({ event: event, formData: newFormData });
        });
    }

    onNext = (e) => {
        e.preventDefault();

        if (validateData(this.state.formData)) {
            this.props.onNext(e);
        } else {
            // Trigger validation here
            this.setState({ wasValidated: true });
        }
    }

    toSubmittableData = () => {
        return {
            vorname: this.state.formData.inputVorname.value,
            nachname: this.state.formData.inputNachname.value,
            mail: this.state.formData.inputMail.value,
            jahrgang: this.state.formData.inputJahrgang.value,
            geschlecht: { value: this.state.formData.inputGeschlecht.value, label: this.state.formData.inputGeschlecht.label },
            verein: this.state.formData.inputVerein.value,
            verband: this.state.formData.inputVerband.value,
            startpass: this.state.formData.inputStartpass.value,
            wettbewerb: { value: this.state.formData.inputWettbewerb.value, label: this.state.formData.inputWettbewerb.label },
        }
    }

    render() {
        const mitStartpass = this.state.event ? this.state.event.sollStartpassErfasstWerden : false;

        const Formular = this.props.step === 0
            ? <FormularInput onNext={this.onNext} formData={this.state.formData} changeListener={this.inputChangeHandler.onChange}
                wasValidated={this.state.wasValidated} wettbewerbe={this.state.event ? this.state.event.wettbewerbe : []} 
                mitStartpass={mitStartpass}/>
            : <AnmeldungSportlerSubmit daten={this.toSubmittableData()} eventId={this.props.match.params.id} 
            onSuccess={() => { this.props.history.push("/thankyou"); }} mitStartpass={mitStartpass} />;

        const wizardStepLabel = this.props.step === 0 ? "Daten eingeben" : "Daten überprüfen";

        const event = this.state.event || {};

        return (
            <div className="jh-content">
                <div className="row" hidden={event === null}>
                    <div className="col-md-12">
                        <h1>{event.name}</h1>
                        <h5 className="jh-subheader">Veranstalter: {event.veranstalter} - Datum: {event.datum}</h5>
                    </div>
                </div>

                <h2><span className="jh-anmeldung-badge">{wizardStepLabel} ({this.props.step + 1}/2)</span></h2>

                <span hidden>Start des Anmeldeformulars</span>
                <div className="row">
                    <div className="col-md-12">
                        {Formular}
                    </div>
                </div>
            </div>
        );
    }
}

const FormularInput = ({ onNext, formData, changeListener, wasValidated, wettbewerbe, mitStartpass }) => {
    const formStyleClasses = "jh-content-form";

    return (
        <form className={formStyleClasses} >
            <div className="form-row">
                <div className="form-group col-md-6">
                    <label htmlFor="inputVorname">Vorname</label>
                    <ValidatableInput name="inputVorname" field={formData.inputVorname} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
                <div className="form-group col-md-6">
                    <label htmlFor="inputNachname">Nachname</label>
                    <ValidatableInput name="inputNachname" field={formData.inputNachname} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-12">
                    <label htmlFor="inputMail">E-Mail-Adresse</label>
                    <ValidatableInput type="email" name="inputMail" field={formData.inputMail} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-6">
                    <label htmlFor="inputJahrgang">Jahrgang</label>
                    <ValidatableInput type="number" name="inputJahrgang" field={formData.inputJahrgang} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
                <div className="form-group col-md-6">
                    <label htmlFor="inputGeschlecht">Geschlecht</label>
                    <ValidatableSelect options={[{ id: "M", bezeichnung: "männlich" }, { id: "W", bezeichnung: "weiblich" }]} name="inputGeschlecht" field={formData.inputGeschlecht} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
            </div>
            <div className="form-row">
                <div className={"form-group " + (mitStartpass ? " col-md-6" : "col-md-8")}>
                    <label htmlFor="inputVerein">Verein/Team</label>
                    <ValidatableInput name="inputVerein" field={formData.inputVerein} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
                {mitStartpass && <div className="form-group col-md-4">
                    <label htmlFor="inputStartpass">Startpass</label>
                    <ValidatableInput name="inputStartpass" field={formData.inputStartpass} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>}
                <div className={"form-group " + (mitStartpass ? " col-md-2" : "col-md-4")}>
                    <label htmlFor="inputVerband">Verband</label>
                    <ValidatableInput name="inputVerband" field={formData.inputVerband} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
            </div>

            <div className="form-row">
                <div className="form-group col-md-12">
                    <label htmlFor="inputWettbewerb">Wettbewerb</label>
                    <ValidatableSelect options={wettbewerbe} name="inputWettbewerb" field={formData.inputWettbewerb} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
            </div>

            <div className="form-row">
                <div className="form-group col-md-12 text-right">
                    <button type="submit" className="btn btn-primary align-bottom jh-btn" onClick={onNext}>Anmelden</button>
                </div>
            </div>

        </form>
    );
}

export default asWizard(AnmeldungSportler);


// WEBPACK FOOTER //
// ./src/components/AnmeldungSportler.js